import { GoogleMap, OverlayView, Marker } from "@react-google-maps/api";

export function CustomInfoWindow({ position, onClose, children }) {
  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div style={styles.container}>
        <div style={styles.closeBtn} onClick={onClose}>
          ×
        </div>
        <div style={styles.content}>{children}</div>
      </div>
    </OverlayView>
  );
}

const styles = {
  container: {
    background: "#fff",
    padding: "5px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
    minWidth: "120px",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    top: 5,
    right: 8,
    cursor: "pointer",
    fontSize: "16px",
  },
  content: {
    marginTop: "10px",
  },
};